import styled from 'styled-components';
import { Text, Title, Icon, Button } from 'components';
import { colorVariables, mediaTemplates } from 'theme/variables';

export const SuccessPurchaseStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-position: left center;
  background-size: cover;
  z-index: 2;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const CircleCheck = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: ${colorVariables.success};
  ${mediaTemplates.l} {
    margin-bottom: 19px;
    width: 80px;
    height: 80px;
  }
`;

export const StyledIcon = styled(Icon)`
  ${mediaTemplates.l} {
    height: 75px;
    width: 75px;
  }
`;

export const InfoWrap = styled.div`
  position: relative;
  margin-bottom: 30px;
  ${mediaTemplates.l} {
    margin-bottom: 35px;
  }
`;

export const StyledTitle = styled(Title)`
  display: block;
  position: relative;
  margin-bottom: 7px;
  font-size: 20px;
  ${mediaTemplates.l} {
    margin-bottom: 20px;
    font-size: 24px;
  }
`;

export const StyledText = styled(Text)`
  position: relative;
  width: 280px;
  margin: auto;
  font-size: 14px;
  line-height: 20px;
  ${mediaTemplates.l} {
    width: 310px;
    font-size: 16px;
  }
`;

export const ButtonsWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  position: relative;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
`;
